import Button from "../core/Button";
import Strings from "../core/data/Strings";
import ResizableContainer from "../core/ResizableContainer";
import ResizableScene from "../core/ResizableScene";
import ScaleManager from "../core/ScaleManager";
import GameColors from "../GameColors";
import PhotoSelectScene from "../scenes/PhotoSelectScene";
import SessionData from "../SessionData";
import Fonts from "../utils/Fonts";
import Overlay from "../utils/Overlay";
import TweenUtils from "../utils/TweenUtils";
import Photo from "./Photo";

export default class UsePhotoPopup extends ResizableContainer {
	photoSelectScene: PhotoSelectScene;
	overlay: Overlay;
	popupContainer: Phaser.GameObjects.Container;
	buttons: Button[];
	photo:Photo;

	constructor(scene: PhotoSelectScene) {
		super(scene, 0, 0);
		this.photoSelectScene = scene;
		const overlay = this.overlay = Overlay.create(scene, 0.8);
		overlay.tint = 0x3a2454;

		const spine = scene.add.spine(0, 0, "camera-flash", "animation", false);
        const spineContainer = scene.add.spineContainer(0, 0, spine);
        scene.alignIn.Center(spineContainer, scene.viewport, 0, -80);

		const popupContainer = this.popupContainer = scene.add.container();
		this.add([overlay, spineContainer, popupContainer]);
		const bg = scene.add.image(0, 0, "confirmBacker");
		popupContainer.add(bg);

		const photoContainer = scene.add.container();
		popupContainer.add(photoContainer);

		const photo = this.photo = new Photo(scene, SessionData.Instance.selectedPhoto, true, true);
		const photoMask = scene.add.image(0, 0, "takePhotoMask");
		photoMask.setDisplaySize(photo.displayWidth, photo.displayHeight);
		photoMask.setVisible(false);
		photoMask.setScale(0.5);
		photoMask.setAngle(-5);
		const mask = photoMask.createBitmapMask();
		photo.setMask(mask);
		const photoRatio = photo.width/photo.height;
		const maskRatio = photoMask.width/photoMask.height;

		if (photoRatio < maskRatio) {
			console.log("Photo is smaller");
			photo.setDisplaySize(photoMask.width, (photoMask.height + photoMask.height * (maskRatio-photoRatio)));
		} else {
			console.log("photo is bigger");
			photo.setDisplaySize((photoMask.width + photoMask.width * (photoRatio - maskRatio)), photoMask.height);
		}
		photo.setScale(1);
		photoMask.setScale(photo.scale);
		photoContainer.add([photo]);
		photoContainer.setScale(0.5);
		photoContainer.setAngle(-5);
		const textStyle = {
			fontFamily: Fonts.LunchBoxRegular,
			fontSize: "45px",
			color: GameColors.WHITE,
			align: "center",
			
		}
		const header = scene.add.text(0, 0, Strings.get("UsePhoto"), textStyle);
		header.setOrigin(0.5);
		header.setLineSpacing(11);
		popupContainer.add(header);
		const corkBacker = scene.add.image(0, 0, "quitCorkBacker");
		popupContainer.add(corkBacker);

		const yesContainer = scene.add.container();
		const yesButton = scene.add.button(0, 0, "yesBtn", 0, this.confirm, this, true);
		yesContainer.add([yesButton]);
		yesContainer.setSize(yesButton.width, yesButton.height);
		yesButton.addPointerDownAnim(TweenUtils.BounceContainer(scene, yesContainer));

		const noContainer = scene.add.container();
		const noButton = scene.add.button(0, 0, "noBtn", 0, this.cancel, this, true);
		noContainer.add([noButton]);
		noContainer.setSize(noButton.width, noButton.height);
		noButton.addPointerDownAnim(TweenUtils.BounceContainer(scene, noContainer));

		popupContainer.add([noContainer, yesContainer]);


		this.addResize((): void => {
			overlay.resize();
			const widthRatio = scene.viewport.width / (popupContainer.width + 60 * 2);
			const heightRatio = scene.viewport.height / (popupContainer.height + 60 * 2 + 100);
			scene.alignIn.Center(popupContainer, scene.viewport, 0, 45);
			scene.alignIn.Center(header, bg, 147, -70);
			scene.alignIn.Center(photoContainer, bg, -88, -45);
			scene.alignIn.LeftCenter(photo, bg, -20, -60);
			scene.alignIn.Center(photoMask, scene.viewport, -153, -25);
			
			scene.alignIn.BottomCenter(corkBacker, bg, 0, -60);
			scene.alignIn.RightCenter(noContainer, corkBacker, -15, 3);
			scene.alignTo.LeftCenter(yesContainer, noContainer, 15, 0);
		});

		// Build in animation sequence
		overlay.setAlpha(0);
		popupContainer.setScale(0);

		scene.tweens.add({
			targets: overlay,
			alpha: 0.8,
			duration: 400,
		});

		scene.tweens.add({
			targets: popupContainer,
			scale: 1,
			duration: 400,
			delay: 300,
			ease: Phaser.Math.Easing.Back.Out,
			onUpdate: ()=> photo.updateMaskPosition()
		});

		this.buttons = [yesButton, noButton];
	}

	tweenOut(): void {
		this.scene.tweens.add({
			targets: this.overlay,
			alpha: 0,
			duration: 400,
		});

		this.scene.tweens.add({
			targets: this.popupContainer,
			scale: 0,
			duration: 400,
			ease: Phaser.Math.Easing.Back.In,
			onComplete: () => this.destroy(),
			onUpdate: ()=> this.photo?.updateMaskPosition()
		});
	}

	protected confirm(): void {
		for (const button of this.buttons) button.disableInteractive();
		const scene = this.scene.scene
		this.photoSelectScene.tweenOut(() => scene.start("PreloaderScene", { destinationScene: "GameScene" }));
		this.tweenOut();
	}

	protected cancel(): void {
		for (const button of this.buttons) button.disableInteractive();
		this.tweenOut();
	}
}